import { Pipe, PipeTransform } from '@angular/core';
import { format, isValid, parseISO } from 'date-fns';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (!value) {
      return '';
    }

    let date: Date;

    // Convert input to Date object
    if (typeof value === 'string') {
      // Try to parse ISO string first, fallback to Date constructor
      date = value.includes('T') || value.includes('-') ? parseISO(value) : new Date(value);
    } else {
      date = new Date(value);
    }

    // Check if date is valid using date-fns
    if (!isValid(date)) {
      return '';
    }

    // Format using date-fns
    return format(date, 'dd/MM/yyyy HH:mm');
  }
}